if (!customElements.get('sb-ty-press')) {
  customElements.define('sb-ty-press', class extends HTMLElement {
    connectedCallback() {
      this.button = this.querySelector('.sb-ty-press__toggle');
      this.mobileQuery = matchMedia('(max-width:749px)');
      const baseLabel = this.getAttribute('aria-label') || 'Presse Florna';
      this.baseLabel = this.baseLabel || baseLabel;
      this.updateLabel = () => this.setAttribute('aria-label', this.mobileQuery.matches ? this.baseLabel + '. Touchez ou appuyez sur Entrée pour mettre en pause ou reprendre.' : this.baseLabel);
      this.updateLabel();
      this.mobileQuery.addEventListener('change', this.updateLabel);
      this.mobileToggle = event => { if (this.mobileQuery.matches && !event.target.closest('button')) this.toggle(); };
      this.keyboardToggle = event => { if (this.mobileQuery.matches && event.target === this && ['Enter', ' '].includes(event.key)) { event.preventDefault(); this.toggle(); } };
      this.addEventListener('click', this.mobileToggle);
      this.addEventListener('keydown', this.keyboardToggle);
      this.toggle = () => {
        const paused = this.dataset.paused !== 'true';
        this.dataset.paused = String(paused);
        this.button.setAttribute('aria-pressed', String(paused));
        this.button.setAttribute('aria-label', paused ? 'Reprendre le défilement presse' : 'Mettre le défilement presse en pause');
        this.button.firstElementChild.textContent = paused ? '▶' : 'Ⅱ';
      };
      this.button?.addEventListener('click', this.toggle);
      this.selectBlock = event => { if (this.contains(event.target)) this.dataset.editorPaused = this.dataset.paused = 'true'; };
      this.deselectBlock = event => { if (this.contains(event.target) && this.dataset.editorPaused === 'true') { this.dataset.paused = this.button?.getAttribute('aria-pressed') === 'true' ? 'true' : 'false'; delete this.dataset.editorPaused; } };
      this.addEventListener('shopify:block:select', this.selectBlock);
      this.addEventListener('shopify:block:deselect', this.deselectBlock);
    }
    disconnectedCallback() {
      this.button?.removeEventListener('click', this.toggle);
      this.mobileQuery?.removeEventListener('change', this.updateLabel);
      this.removeEventListener('click', this.mobileToggle);
      this.removeEventListener('keydown', this.keyboardToggle);
      this.removeEventListener('shopify:block:select', this.selectBlock);
      this.removeEventListener('shopify:block:deselect', this.deselectBlock);
    }
  });
}

if (!customElements.get('sb-ty-calendar')) {
 customElements.define('sb-ty-calendar', class extends HTMLElement {
  connectedCallback() {
   this.abort?.abort();
   this.abort = new AbortController();
   this.querySelector('button').addEventListener('click', () => {
    const date = this.dataset.date || '';
    const start = new Date(date + 'T00:00:00Z');
    const status = this.querySelector('[role="status"]');
    if (!/^\d{4}-\d{2}-\d{2}$/.test(date) || Number.isNaN(start.valueOf()) || start.toISOString().slice(0,10) !== date) {
     status.textContent = 'La date du rappel doit être renseignée au format AAAA-MM-JJ.';
     return;
    }
    const end = new Date(start); end.setUTCDate(end.getUTCDate() + 1);
    const escapeICS = value => String(value || '').replace(/\\/g, '\\\\').replace(/\r?\n/g, '\\n').replace(/,/g, '\\,').replace(/;/g, '\\;');
    const compact = value => value.toISOString().replace(/[-:]/g, '').replace(/\.\d{3}/, '');
    const lines = ['BEGIN:VCALENDAR','VERSION:2.0','PRODID:-//Florna//VIP//FR','CALSCALE:GREGORIAN','BEGIN:VEVENT',
     'UID:florna-' + date + '@' + location.hostname,
     'DTSTAMP:' + compact(new Date()),'DTSTART;VALUE=DATE:' + date.replace(/-/g,''),
     'DTEND;VALUE=DATE:' + end.toISOString().slice(0,10).replace(/-/g,''),
     'SUMMARY:' + escapeICS(this.dataset.title),
     'DESCRIPTION:' + escapeICS(this.dataset.description + (this.dataset.url ? '\n' + this.dataset.url : '')),
     'BEGIN:VALARM','TRIGGER:-PT9H','ACTION:DISPLAY','DESCRIPTION:Rappel Florna','END:VALARM','END:VEVENT','END:VCALENDAR'];
    const fold = line => { let output = '', size = 0; for (const character of line) { const bytes = new TextEncoder().encode(character).length; if(size + bytes > 73){output += '\r\n '; size = 1;} output += character; size += bytes;} return output; };
    const url = URL.createObjectURL(new Blob([lines.map(fold).join('\r\n') + '\r\n'], {type:'text/calendar;charset=utf-8'}));
    const link = document.createElement('a'); link.href = url; link.download = 'florna-vip.ics'; this.append(link); link.click(); link.remove();
    setTimeout(() => URL.revokeObjectURL(url), 1000);
    status.textContent = 'Ouvrez le fichier téléchargé pour ajouter le rappel à votre calendrier.';
   }, {signal:this.abort.signal});
  }
  disconnectedCallback() {this.abort?.abort();}
 });
}

if (!customElements.get('sb-florna-ty-carousel')) {
  customElements.define('sb-florna-ty-carousel', class extends HTMLElement {
    connectedCallback() {
      this.abort?.abort(); this.observer?.disconnect();
      this.abort = new AbortController();
      const signal = this.abort.signal;
      this.track = this.querySelector('[data-track]');
      if (!this.track) {
        if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => { if (this.isConnected) this.connectedCallback(); }, {once:true, signal});
        return;
      }
      this.dots = this.querySelector('[data-dots]');
      this.cards = [...this.track.children];
      this.extraNav=this.querySelector('[data-extra-nav]');this.prev=this.querySelector('[data-prev]');this.next=this.querySelector('[data-next]');this.progress=this.querySelector('[data-progress]');
      const go=direction=>{const i=Math.max(0,Math.min(this.positions.length-1,(this.active||0)+direction));this.track.scrollTo({left:this.positions[i]||0,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'});};
      this.prev?.addEventListener('click',()=>go(-1),{signal});this.next?.addEventListener('click',()=>go(1),{signal});
      this.refresh = () => {
        const max = Math.max(0, this.track.scrollWidth - this.track.clientWidth);
        const origin = this.cards[0]?.offsetLeft || 0;
        this.positions = [...new Set(this.cards.map(card => Math.round(Math.min(max, Math.max(0, card.offsetLeft - origin)))))];
        this.dots.replaceChildren();
        this.dots.hidden = max < 2 || this.positions.length < 2;
        if(this.extraNav)this.extraNav.hidden=this.dots.hidden;
        this.positions.forEach((left, index) => {
          const button = document.createElement('button');
          button.type = 'button';
          button.setAttribute('aria-label', `${this.dataset.paginationLabel} ${index + 1}`);
          button.addEventListener('click', () => this.track.scrollTo({left, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'}));
          this.dots.append(button);
        });
        this.update();
      };
      this.update = () => {
        let active = 0;
        this.positions?.forEach((left, index) => { if (Math.abs(this.track.scrollLeft-left) < Math.abs(this.track.scrollLeft-this.positions[active])) active=index; });
        this.active=active;if(this.prev)this.prev.disabled=active===0;if(this.next)this.next.disabled=active>=this.positions.length-1;if(this.progress)this.progress.value=this.positions.length>1?active/(this.positions.length-1)*100:100;
        [...this.dots.children].forEach((button,index) => button.setAttribute('aria-current', String(index===active)));
      };
      this.track.addEventListener('scroll', this.update, {passive:true, signal});
      this.addEventListener('shopify:block:select', event => {
        const card=event.target.closest('[data-card]');
        if(card) this.track.scrollTo({left:card.offsetLeft-(this.cards[0]?.offsetLeft||0),behavior:'auto'});
      }, {signal});
      this.observer = new ResizeObserver(this.refresh);
      this.observer.observe(this.track);
      this.cards.forEach(card=>this.observer.observe(card));
      this.refresh();
    }
    disconnectedCallback() { this.abort?.abort(); this.observer?.disconnect(); }
  });
}

if (!customElements.get('sb-ty-results')) {
 customElements.define('sb-ty-results', class extends HTMLElement {
  connectedCallback() {
   this.abort?.abort(); this.resize?.disconnect(); this.abort=new AbortController();
   const viewport=this.querySelector('.sb-ty-results__viewport'); if(!viewport)return;
   const cards=[...this.querySelectorAll('[data-sb-card]')], dots=[...this.querySelectorAll('[data-sb-dot]')];
   const nav=this.querySelector('.sb-ty-results__navigation'), progress=this.querySelector('progress'), prev=this.querySelector('[data-sb-prev]'), next=this.querySelector('[data-sb-next]');
   if(!cards.length)return;
   const position=card=>card.getBoundingClientRect().left-viewport.getBoundingClientRect().left+viewport.scrollLeft;
   let positions=[],active=0;
   const move=left=>viewport.scrollTo({left,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'});
   const update=()=>{
    const max=Math.max(0,viewport.scrollWidth-viewport.clientWidth);
    positions=[...new Set(cards.map(card=>Math.round(Math.min(max,Math.max(0,position(card))))))].sort((a,b)=>a-b);
    active=positions.reduce((best,left,i)=>Math.abs(left-viewport.scrollLeft)<Math.abs(positions[best]-viewport.scrollLeft)?i:best,0);
    if(nav)nav.hidden=max<=1;
    if(progress){progress.hidden=max<=1;progress.value=max?viewport.scrollLeft/max*100:0;}
    if(prev)prev.disabled=viewport.scrollLeft<=1;
    if(next)next.disabled=viewport.scrollLeft>=max-1;
    dots.forEach((dot,i)=>{dot.hidden=i>=positions.length;dot.setAttribute('aria-pressed',String(i===active));});
   };
   const options={signal:this.abort.signal};
   viewport.addEventListener('scroll',update,{...options,passive:true});
   prev?.addEventListener('click',()=>{const target=[...positions].reverse().find(x=>x<viewport.scrollLeft-1);if(target!==undefined)move(target);},options);
   next?.addEventListener('click',()=>{const target=positions.find(x=>x>viewport.scrollLeft+1);if(target!==undefined)move(target);},options);
   dots.forEach((dot,i)=>dot.addEventListener('click',()=>{if(positions[i]!==undefined)move(positions[i]);},options));
   this.addEventListener('shopify:block:select',event=>{const card=cards.find(card=>card===event.target||card.contains(event.target));if(card)move(position(card));},options);
   this.resize=new ResizeObserver(update);this.resize.observe(viewport);cards.forEach(card=>this.resize.observe(card));update();
  }
  disconnectedCallback(){this.abort?.abort();this.resize?.disconnect();}
 });
}
